import { formatDateCSV } from "../getDate"

export const exportFileName = (fileName: string) =>
  `${fileName}_${formatDateCSV()}`
